export enum HTTP_HEADER {
  'X-CSRF-TOKEN' = 'X-CSRF-TOKEN',
}
